import React from 'react'
import Head from 'next/head'

// ////////////////////////////////////////////////////////// COMPONENTS
import { TextLink } from '../../../ui/link'
import { UnOrderedList, BasicListItem } from '../../../ui/Lists'

// ////////////////////////////////////////////////////////////// HELPER

// /////////////////////////////////////////////////////////////// STYLE
import style from './styles/TeamPage.module.scss'

// /////////////////////////////////////////////////////////////// TYPES
type PropsType = {
  children?: React.ReactNode
  teams: Array<any>
  teamName: string
  headerTitle?: string
}

const TeamPage = ({
  children,
  teams,
  teamName,
  headerTitle = '',
}: PropsType): React.ReactElement => (
  <section className="page__content fs-unmask">
    <Head>
      <title>{headerTitle}</title>
    </Head>
    <div className={style.header}>
      <div>
        <h2>{headerTitle}</h2>
      </div>
      <div>
        <UnOrderedList>
          {teams.map(team => {
            return (
              <BasicListItem key={team.id}>
                <TextLink
                  to={team.to}
                  as={team.as}
                  className={style.links}
                  active={team.id == teamName}
                >
                  {team.title}
                </TextLink>
              </BasicListItem>
            )
          })}
        </UnOrderedList>
      </div>
    </div>
    {children}
  </section>
)

// /////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////// EXPORT DEFAULT
export default TeamPage
